import Vue from 'vue';
import Vuesax from 'vuesax';
import 'vuesax/dist/vuesax.css';
import themeConfig from '../../themeConfig';
import 'material-icons/iconfont/material-icons.css';

Vue.use(Vuesax, { theme: { colors: themeConfig.colors } });
Vue.prototype.$colors = themeConfig.colors;
